import React, { useEffect, useMemo, useState } from "react";
import { ParticipantTabNavs } from "@/shared/components/tabNavs";
import { Table, Col, Row, Container } from "reactstrap";
import { connect } from "react-redux";
import { useTable } from "react-table";
import { GOAL_COLUMNS } from "./components/columns";
import { Link } from "react-router-dom";
import Sidebar from "@/containers/Layout/sidebar";
import ClearPageLayout from "@/containers/Participant/components/ClearPageLayout";
import { useTranslation } from "react-i18next";
import { readActiveByProgramAndUser } from "@/services/user/readActiveByProgramAndUser";

const CLASSIC_IMG_BACK = `${process.env.PUBLIC_URL}/theme/classic/img/pages/my-points.jpg`;

const Goals = ({ template, auth, organization, program }) => {
  const { t } = useTranslation();
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!organization?.id || !program?.id || !auth?.id) {
      return;
    }

    setLoading(true);
    readActiveByProgramAndUser(organization.id, program.id, auth.id)
      .then((data) => {
        setGoals(data || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setGoals([]);
        setLoading(false);
      });
  }, [auth?.id, organization?.id, program?.id]);

  const columns = useMemo(
    () => [
      ...GOAL_COLUMNS,
      {
        Header: "",
        accessor: "action",
        Cell: ({ row }) => (
          <Link to={`/participant/my-goals/${row.original.id}`} className="goals-list__action">
            {t("view_details")}
          </Link>
        ),
      },
    ],
    [t]
  );

  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: goals,
  });

  const GoalsTable = () => {
    if (loading) {
      return (
        <div className="goals-list goals-list--state">
          <p className="goals-list__state">{t("loading")}</p>
        </div>
      );
    }

    if (rows.length === 0) {
      return (
        <div className="goals-list goals-list--state">
          <p className="goals-list__state">{t("no_activity_yet")}</p>
        </div>
      );
    }

    return (
      <div className="goals-list">
        <div className="goals-list__table-wrap">
          <Table striped borderless size="md" className="goals-list__table table--stack-mobile" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>{t(column.Header)}</th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td
                        {...cell.getCellProps()}
                        data-label={typeof cell.column.Header === "string" ? t(cell.column.Header) : ""}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    );
  };

  const GoalsClear = () => (
    <div className="goals-page">
      <div className="goals-page__header">
        <Container>
          <div className="goals-page__header-inner">
            <div>
              <h1 className="goals-page__title">{t("my_goals")}</h1>
            </div>
          </div>
        </Container>
      </div>

      <Container className="goals-page__body">
        <ClearPageLayout>
          <GoalsTable />
        </ClearPageLayout>
      </Container>
    </div>
  );

  const GoalsClassic = () => (
    <>
      <div className="mainboard">
        <img src={CLASSIC_IMG_BACK} alt={t("my_goals")} />
        <div className="title">{t("my_goals")}</div>
      </div>

      <Container>
        <ParticipantTabNavs />
      </Container>

      <Container>
        <Row>
          <Col md={9}>
            <div className="dashboard">
              <GoalsTable />
            </div>
          </Col>
          <Col md={3}>
            <Sidebar />
          </Col>
        </Row>
      </Container>
    </>
  );

  return (
    (template?.name === "clear" && <GoalsClear />) ||
    (template?.name === "classic" && <GoalsClassic />) ||
    <GoalsClear />
  );
};

const mapStateToProps = (state) => ({
  template: state.template,
  auth: state.auth,
  program: state.program,
  organization: state.organization,
});

export default connect(mapStateToProps)(Goals);
